import React from 'react';
import CustomTextInput from '../../../common/components/CustomTextInput';
import { FieldValidationErrorsType } from '../../../common/form/FrekulForm';
import CustomCheckbox from '../../../common/components/CustomCheckbox';

type KaraokeOrderFormView2MetadataInputFieldName =
  'title'|'title_kana'|'artist_name'|'artist_name_kana'|
  'lyric_writer_name'|'composer_name'|'applicant_name'|
  'use_vocal_synthesizer'|'vocal_synthesizer_name';

export default function KaraokeOrderFormView2MetadataInput({
  getValue,
  setValue,
  getErrors,
} : {
  getValue: (name: KaraokeOrderFormView2MetadataInputFieldName) => string,
  setValue: (name: KaraokeOrderFormView2MetadataInputFieldName, value: string) => void,
  getErrors: (name: KaraokeOrderFormView2MetadataInputFieldName) => FieldValidationErrorsType,
}) {
  return (
    <>
      <h2>
        曲の情報
      </h2>
      <div className="form__body">
        <dl className="fm_2">
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="song">曲名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Frekul Song"
              value={getValue('title')}
              setValue={(value) => setValue('title', value)}
              validationErrors={getErrors('title')}
            />
          </dd>
        </dl>
        <dl className="fm_2">
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="song hiragana">曲名読み（ひらがな）</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="ふりくるそんぐ"
              value={getValue('title_kana')}
              setValue={(value) => setValue('title_kana', value)}
              validationErrors={getErrors('title_kana')}
            />
          </dd>
        </dl>
        <dl className="fm_2">
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="artist">アーティスト名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="Frekul Band"
              value={getValue('artist_name')}
              setValue={(value) => setValue('artist_name', value)}
              validationErrors={getErrors('artist_name')}
            />
          </dd>
        </dl>
        <dl className="fm_2">
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="artist hiragana">アーティスト名読み（ひらがな）</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="ふりくるばんど"
              value={getValue('artist_name_kana')}
              setValue={(value) => setValue('artist_name_kana', value)}
              validationErrors={getErrors('artist_name_kana')}
            />
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="songwriter">作詞者名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="鈴木 太郎"
              value={getValue('lyric_writer_name')}
              setValue={(value) => setValue('lyric_writer_name', value)}
              validationErrors={getErrors('lyric_writer_name')}
            />
            <p className="text_info">作詞者名として公開されます。印税の受取人名とは別です。</p>
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="composer">作曲者名</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="鈴木 太郎"
              value={getValue('composer_name')}
              setValue={(value) => setValue('composer_name', value)}
              validationErrors={getErrors('composer_name')}
            />
            <p className="text_info">作曲者名として公開されます。印税の受取人名とは別です。</p>
          </dd>
        </dl>
        <dl>
          <dt>
            { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
            <label htmlFor="your name">申込者名（個人名または法人名）</label>
          </dt>
          <dd>
            <CustomTextInput
              placeholder="鈴木 太郎"
              value={getValue('applicant_name')}
              setValue={(value) => setValue('applicant_name', value)}
              validationErrors={getErrors('applicant_name')}
            />
            <p className="text_info">公開されません。必ずあなたの本名か、法人名（会社名）を書いてください。法人ではない団体名、バンド名、アーティスト名は不可。</p>
          </dd>
        </dl>
        <dl>
          <dd>
            <CustomCheckbox
              checked={getValue('use_vocal_synthesizer') === '1'}
              setChecked={(checked) => setValue('use_vocal_synthesizer', checked ? '1' : '0')}
            >
              音源や映像に音声合成ソフト（ボカロ）を使用している
            </CustomCheckbox>
          </dd>
        </dl>
        {getValue('use_vocal_synthesizer') === '1' && (
          <dl>
            <dt>
              { /* eslint-disable-next-line jsx-a11y/label-has-associated-control */ }
              <label htmlFor="vocal_synthesizer">使用しているキャラクター</label>
            </dt>
            <dd>
              <CustomTextInput
                placeholder=""
                value={getValue('vocal_synthesizer_name')}
                setValue={(value) => setValue('vocal_synthesizer_name', value)}
                validationErrors={getErrors('vocal_synthesizer_name')}
              />
              <p className="text_info">キャラクターを複数使用している場合、全て入力してください。</p>
            </dd>
          </dl>
        )}
      </div>
    </>
  );
}
